module.exports = __webpack_public_path__ + "static/media/logo.493f522c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/logo.svg
// module id = 487
// module chunks = 0